export interface ICustomerState {
  activeCustomer: string;
}

export const initialCustomerState: ICustomerState = {
  activeCustomer: "",
};
